﻿/* 
Object:         Addressbook
Description:    Logic and events for the module Addressbook
Used in:        Addressbook
*/

/*---[ ESLint ]---*/
/*
    global webServiceCredentials
*/

window.webServiceCredentials = function () {

    var LABEL_ETooManyDays = "";
    var LABEL_ENoDataFound = "";

    function showHideWebService(objectType) {

        //main.setHideDivBootstrap("TRUserName", false);
        //main.setHideDivBootstrap("TRPassword", false);
        main.setHideDivBootstrap("TRTimezone", false);
        //main.setHideDivBootstrap("TRCommPeriod", false);
        //main.setHideDivBootstrap("TRCommFrom", false);
        //main.setHideDivBootstrap("TRRetryInterval", false);
        //main.setHideDivBootstrap("TRMaxRetries", false);
        main.setHideDivBootstrap("TRMoveFile", false);
        main.setHideDivBootstrap("TRRegio", false);
        main.setHideDivBootstrap("TRGroupOrNodeName", false);
        main.setHideDivBootstrap("TRCustomOccupancyText", false);
        main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", false);
        main.setHideDivBootstrap("TRGMS", false);

        switch (objectType) {
            case webService_ObjectTypeEnum.Outgoing_GMS_VerbindingStatusRequest_V5:
                main.setHideDivBootstrap("TRGMS", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_VerbindingStatusRequest_V6:
                main.setHideDivBootstrap("TRGMS", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_VerbindingStatusRequest_V7:
                main.setHideDivBootstrap("TRGMS", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_VerbindingStatusRequest_V8:
                main.setHideDivBootstrap("TRGMS", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_IncidentSynchronisatieRequest_V5:
                main.setHideDivBootstrap("TRGMS", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_IncidentSynchronisatieRequest_V6:
                main.setHideDivBootstrap("TRGMS", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_IncidentSynchronisatieRequest_V7:
                main.setHideDivBootstrap("TRGMS", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_IncidentSynchronisatieRequest_V8:
                main.setHideDivBootstrap("TRGMS", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_Incident_aansluiting_V5:
                main.setHideDivBootstrap("TRCustomOccupancyText", true);
                main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_Incident_aansluiting_V6:
                main.setHideDivBootstrap("TRCustomOccupancyText", true);
                main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_Incident_aansluiting_V7:
                main.setHideDivBootstrap("TRCustomOccupancyText", true);
                main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", true);
                break;
            case webService_ObjectTypeEnum.Outgoing_GMS_Incident_aansluiting_V8:
                main.setHideDivBootstrap("TRCustomOccupancyText", true);
                main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", true);
                break;
            case webService_ObjectTypeEnum.Incomming_GMS_Incident_aansluiting: // 7                
                main.setHideDivBootstrap("TRRegio", true);
                main.setHideDivBootstrap("TRGroupOrNodeName", true);                
                break;
        }
    }

    function showHideCommMethod(commMethod) {
        if (commMethod == 'Interval') {
            main.setHideDivBootstrap("TRCommPeriod", true);
            main.setHideDivBootstrap("TRCommFrom", false);
            main.setHideDivBootstrap("TRRetryInterval", false);
            main.setHideDivBootstrap("TRMaxRetries", false);
        } else {
            main.setHideDivBootstrap("TRCommPeriod", false);
            main.setHideDivBootstrap("TRCommFrom", true);
            main.setHideDivBootstrap("TRRetryInterval", true);
            main.setHideDivBootstrap("TRMaxRetries", true);
        }
    }

    return {

        /**
         * Init (binding button actions) Overview grid
         */
        initialize: function () {
            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("WebServiceCredentials/Add");
            });
        },

        /**
         * Delete item from grid
         * @param {any} e
         */
        deleteItem: function (e) {
            var event = e;
            var data = this;

            function callbackYes(event, data) {

                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                // Post Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("WebServiceCredentials/Delete?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID),
                    success: function (responseData) {

                        // Refresh datasource grid 
                        $("#WebServiceCredentials").data("kendoGrid").dataSource.read();

                    }
                });
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },

        /**
         * Update a item from grid
         * @param {any} e
         */
        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Label;

            // Edit mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("WebServiceCredentials/Edit?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID + "&breadcrumbLabel=" + label);
        },

        /**
         * Show item from grid
         * @param {any} e
         */
        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Label;

            // Show mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("WebServiceCredentials/Show?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID + "&breadcrumbLabel=" + label);
        },

        loggingItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Label;

            // Show mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("WebServiceCredentials/Log?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID + "&breadcrumbLabel=" + label);
        },

        usersItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.Label;

            // Show mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("WebServiceCredentials/Users?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID + "&breadcrumbLabel=" + label);
        },

        formInitialize: function () {
            var objectType = $("#WebServiceID").data("kendoDropDownList").dataItem().ParentValue;
            showHideWebService(parseInt(objectType));

            var commMethod = $('#CommMethod').val();
            showHideCommMethod(commMethod);
        },

        webServiceChanged: function (e) {
            showHideWebService(parseInt(e.sender.dataItem().ParentValue));
        },

        commMethodChanged: function (e) {
            showHideCommMethod(e.sender.element[0].value);
        },

        callIncidentBrokerClicked: function (formId, webServiceCredentialsId, method) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("WebServiceCredentials/CallIncidentBrokerService"),
                data: { webServiceCredentialsId: webServiceCredentialsId, method: method },
                success: function (responseData) {
                    if (responseData != undefined) {
                        form.showServerResponse(formId, responseData);
                    }
                }
            });
        },

        visibilityItem: function (dataItem) {
            var objectType = parseInt(dataItem.WebService_ObjectType);
            return (objectType == webService_ObjectTypeEnum.Import_AG5 || objectType == webService_ObjectTypeEnum.Import_AED_Alert);
        },

        logInitialize: function (ETooManyDays, ENoDataFound) {
            LABEL_ETooManyDays = ETooManyDays;
            LABEL_ENoDataFound = ENoDataFound;

            main.setHideDivBootstrap("periodSelector", false);

            webServiceCredentials.searchButtonClicked();
        },

        searchButtonClicked: function () {
            $("#SearchButtonLoader").show();

            main.setHideDiv("DivLblTooMany", false);

            var grid = $("#WebServiceCredentialsLogGrid").data("kendoGrid");
            if (grid != null && grid != undefined) {
                grid.pager.dataSource.page(1);
                grid.dataSource.read();
            }
        },

        getAdditionalData: function (webServiceCredentialsId) {

            // defaults
            var beginDateTime = moment();
            var toLocal = new Date(beginDateTime.unix() * 1000);
            var fromLocal = new Date(beginDateTime.subtract(1, 'days').unix() * 1000);

            // timeinterval
            var ddl = $("#TimeInterval").data("kendoDropDownList");
            if (ddl != null && ddl != undefined) {
                var ddlval = parseInt(ddl.value());
                fromLocal = timeinterval.GetBeginPeriodSelection(ddlval);
                toLocal = timeinterval.GetEndPeriodSelection(ddlval);

                var tsDays = (toLocal - fromLocal) / (1000 * 3600 * 24);
                if (tsDays >= 33) {

                    // make a message
                    main.setHideDiv("DivLblTooMany", true);

                    var lblEmsg = $("#LblTooMany");
                    if (lblEmsg != null && lblEmsg != undefined) {
                        lblEmsg.text(LABEL_ETooManyDays);
                    }

                    fromLocal = toLocal = new Date(Date.now());
                }
            }

            return {
                webServiceCredentialsId: webServiceCredentialsId,
                timestampFrom: fromLocal,
                timestampTo: toLocal
            };
        },

        onChangeTimeInterval: function (e) {
            var show = e.sender.element[0].value == timeIntervalEnum.AskedPeriod;
            main.setHideDivBootstrap("periodSelector", show);
        },

        onDataBound: function (e) {
            $("#SearchButtonLoader").hide();

            if (e.sender.dataSource.view().length < 1) {
                main.setHideDiv("DivGridMsg", true);
                var lblEmsg = $("#LblGridMsg");
                if (lblEmsg != null && lblEmsg != undefined) {
                    lblEmsg.text(LABEL_ENoDataFound);
                }
            }
        },

        /**
        * Init Users
        * @param {string} notsaved
        */
        //users_initialize: function (notsaved) {
        //    _msg_notsaved = notsaved;
        //},

        /**
        * Users - LDataNotSaved (label)
        */
        //users_Get_LDataChangedNotSavedYet: function () {
        //    return _msg_notsaved;
        //},


        /**
        * Users - Enable save button
        */
        users_enableSaveButton: function () {
            var btnSave = document.getElementById("saveButtonUsers");
            btnSave.removeAttribute("disabled");
        },

        /**
        * Users - Disable save button
        */
        users_disableSaveButton: function () {
            var btnSave = document.getElementById("saveButtonUsers");
            btnSave.setAttribute("disabled", "disabled");
        },

        /**
        * Users - Left clicked
        */
        users_leftClicked: function () {
            webServiceCredentials.users_enableSaveButton();
            listbox.moveItems("WebServiceCredentials_Users_CplSelected", "WebServiceCredentials_Users_CplNotSelected", "#Users_Validation", webServiceCredentials.users_Get_LDataChangedNotSavedYet);
        },

        /**
        * Users - Right clicked
        */
        users_rightClicked: function () {
            webServiceCredentials.users_enableSaveButton();
            listbox.moveItems("WebServiceCredentials_Users_CplNotSelected", "WebServiceCredentials_Users_CplSelected", "#Users_Validation", webServiceCredentials.users_Get_LDataChangedNotSavedYet);
        },


        /**
        * Users - Save button clicked
        * @param {string} actionUrl
        * @param {number} webServiceCredentialsId
        */
        users_saveButtonClicked: function (actionUrl, webServiceCredentialsId) {

            webServiceCredentials.users_disableSaveButton();

            var json = $("#WebServiceCredentials_Users_CplSelected").data("kendoListBox").dataSource.view();
            var list = json.slice();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { list: kendo.stringify(list), webServiceCredentialsId: webServiceCredentialsId },
                success: function (responseData) {

                    $('#Users_Validation').text("");

                    if (responseData.Succesfully) {
                        if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                            Function(responseData.CallbackJS)(); // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                        }
                    } else {
                        $('#WebServiceCredentials_Users_CplNotSelected').data("kendoListView").dataSource.read();
                        $('#WebServiceCredentials_Users_CplSelected').data("kendoListView").dataSource.read();
                    }

                    var color = (responseData.Success ? 'green' : 'red');
                    $('#Users_Validation').text(responseData.Message);
                    $('#Users_Validation').attr('style', 'color:' + color);
                }
            });
        }
    }
}();